import { combineReducers } from 'redux';

import { user } from '../../components/Login/reducers';

export default combineReducers({
  users: user
});



// WEBPACK FOOTER //
// ./src/common/store/reducer.js